module.exports = __webpack_public_path__ + "media/images/page/pickup-sample-6a6821d26cc1b238fcf8f8cf13706d01.jpg";